import { BreadcrumbsComponent } from '@components/Breadcrumbs';
import { PageHead } from '@components/PageHead';
import { SidebarV2, useSidebarV2 } from '@components/SidebarV2';
import { Box, Stack } from '@mui/material';
import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import './index.css';

interface BreadcrumbItem {
    label: string;
    href?: string;
    value?: string;
}

interface LayoutProps {
    children: ReactNode | ReactNode[];
    breadcrumbs?: BreadcrumbItem[];
    heading?: string;
}

export const Layout: React.FC<LayoutProps> = ({ children, breadcrumbs, heading }) => {
    const location = useLocation();
    const { sidebarWidth, nestedSidebarWidth } = useSidebarV2();

    const isAuthPage = location.pathname.includes('auth');

    return (
        <>
            <PageHead title={heading} useDynamicTitle={!heading} />
            <Box
                sx={{
                    marginLeft: `${sidebarWidth}px`,
                    transition: 'margin-left 0.3s ease',
                    bgcolor: theme => theme.palette.neutralBlack.main,
                    paddingTop: '0px',
                    marginTop: '0px',
                    overflow: 'hidden',
                }}>
                <Stack
                    id="layout-container"
                    sx={{
                        minHeight: '100vh',
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                    {!isAuthPage && <SidebarV2 />}
                    {breadcrumbs && heading && (
                        <Box
                            sx={{
                                paddingLeft: nestedSidebarWidth > 0 ? `${nestedSidebarWidth}px` : 0,
                            }}
                        >
                            <BreadcrumbsComponent items={breadcrumbs} heading={heading} />
                        </Box>
                    )}
                    <Stack sx={{
                        padding: '0px 24px',
                        flex: 1,
                        minHeight: '100%',
                    }}>
                        {children}
                    </Stack>
                </Stack>
            </Box>
        </>
    );
};
